import React from 'react'
import PropTypes from 'prop-types'
import { Map, List, fromJS } from 'immutable'
import railsPostFetch from '@aytm/lib/common/rails-post-fetch'
import InvoiceTableRow from '@aytm/lib/rfd-ui/components/payment/invoice-table/row'
// import TextField from '@aytm/lib/rfd-ui/components/basic/text-field'
import LightBox from '@aytm/lib/rfd-ui/components/basic/light-box'
import Select from '@aytm/lib/rfd-ui/components/basic/select'
import TextField from '@aytm/lib/rfd-ui/components/basic/text-field'
import Button from '@aytm/lib/rfd-ui/components/basic/button'
import Popup, { PopupTrigger } from '@aytm/lib/rfd-ui/components/basic/popup'

import '@aytm/lib/rfd-ui/styles/payment/address.scss'
import classNames from 'classnames'

export default class InvoiceTableAddressRow extends InvoiceTableRow {
  static propTypes = {
    row: PropTypes.instanceOf(Map).isRequired,
    width: PropTypes.number,
    valuesWidth: PropTypes.number,
    onChange: PropTypes.func
  }

  constructor(props) {
    super(props)
    this.changeEdit = this.changeEdit.bind(this);
    this.getCountries = this.getCountries.bind(this);
    this.setCountry = this.setCountry.bind(this);
    this.checkAddress = this.checkAddress.bind(this);
    this.setAddress = this.setAddress.bind(this);
    this.renderWindow = this.renderWindow.bind(this);
    this.renderEmptyState = this.renderEmptyState.bind(this);
    this.cancelEdit = this.cancelEdit.bind(this);
    this.state = {
      edit: false,
      checking: false,
      message: null,
      error: false,
      countries: List([]),
      states: List([]),
      loading: false,
      country: props.row.get('data') ? props.row.getIn(['data', 'country_id']) : null,
      errors: fromJS({
        country_id: null,
        line1: null,
        postal_code: null,
        city: null,
        state_id: null,
        base: null
      })
    }
    this.address = {
      country_id: props.row.get('data') ? props.row.getIn(['data', 'country_id']) : '',
      line1: props.row.get('data') ? props.row.getIn(['data', 'line1']) : '',
      postal_code: props.row.get('data') ? props.row.getIn(['data', 'postal_code']) : '',
      city: props.row.get('data') ? props.row.getIn(['data', 'city']) : '',
      state_id: props.row.get('data') ? props.row.getIn(['data', 'state_id']) : ''
    }
  }

  UNSAFE_componentWillReceiveProps() {
    super.UNSAFE_componentWillReceiveProps()
    this.setState({
      checking: false,
      edit: false,
      message: null
    })
  }

  componentDidMount() {
    super.componentDidMount()
  }

  changeEdit() {
    if (!this.state.edit && !this.state.countries.size) this.getCountries()
    this.setState({ edit: !this.state.edit })
  }

  getCountries() {
    const { row } = this.props

    if (row.get('updateUseAddressURL')) {
      railsPostFetch(row.get('updateUseAddressURL') + '/countries-list')
        .then(response => response.json())
        .then(data => {
          this.setState({
            countries: fromJS(data),
            states: fromJS(data[0].v)
          })
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log(error)
        })
    }
  }

  setCountry(c) {
    const { errors } = this.state
    errors['country_id'] = null
    errors['base'] = null
    this.setState({ errors: errors, country: c.get('value') })
    this.address.country_id = c.get('value')
  }

  checkAddress() {
    const { row, onChange } = this.props
    this.setState({ loading: true })
    if (row.get('updateUseAddressURL')) {
      railsPostFetch(row.get('updateUseAddressURL'), {
        body: JSON.stringify({ physical_address: this.address })
      })
        .then(response => response.json())
        .then(data => {
          this.setState({ loading: false })
          if ('fail' == data.status) {
            const errors = Object.entries(data.errors).reduce((prev, cur) => prev.set(cur[0], true), this.state.errors)
            this.setState({ errors: data.errors.base ? errors.set('base', data.errors.base[0]) : errors })
          } else {
            this.changeEdit()
            if ('function' == typeof onChange) onChange()
          }
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log(error)
        })
    }
  }

  setAddress(tag, value) {
    const { errors } = this.state
    this.setState({ errors: errors.set(tag, null).set('base', null) })
    this.address[tag] = value
  }

  renderWindow() {
    const { countries, states, country, errors, loading } = this.state
    const { row } = this.props
    return (
      <LightBox onClose={this.changeEdit}>
        <div className="rfd-ui-invoice-table-address-window">
          <div className="rfd-ui-invoice-table-address-close-button" onClick={this.changeEdit}>
            X
          </div>
          <div className="rfd-ui-invoice-table-address-window-header">
            <span>
              <b>Physical address</b>
              <br />
            </span>
            <span>
              To determine sales taxes, please provide the physical address <br /> where you will use your data and
              insights.
            </span>
            <br />
            {errors['base'] && <span className="error">{errors.get('base')}</span>}
          </div>
          <div className="rfd-ui-invoice-table-address-window-prop-row">
            <span
              className={classNames('rfd-ui-invoice-table-address-window-prop-row-title', {
                error: errors.get('country_id')
              })}
            >
              Country:
            </span>
            <Select
              options={countries}
              width={270}
              placeholder="Please select"
              onSelect={this.setCountry}
              value={row.get('data') ? row.getIn(['data', 'country_id']) : null}
              disabled={!countries.size}
            />
          </div>
          <div className="rfd-ui-invoice-table-address-window-prop-row">
            <span
              className={classNames('rfd-ui-invoice-table-address-window-prop-row-title', {
                error: errors.get('line1')
              })}
            >
              Address:
            </span>
            <TextField
              width={270}
              debounce={100}
              onChange={v => this.setAddress('line1', v)}
              value={row.get('data') ? row.getIn(['data', 'line1']) : ''}
              charLimit={150}
            />
          </div>
          <div className="rfd-ui-invoice-table-address-window-prop-row">
            <span
              className={classNames('rfd-ui-invoice-table-address-window-prop-row-title', {
                error: errors.get('city')
              })}
            >
              City:
            </span>
            <TextField
              width={270}
              debounce={100}
              onChange={v => this.setAddress('city', v)}
              value={row.get('data') ? row.getIn(['data', 'city']) : ''}
              charLimit={150}
            />
          </div>
          {18302 == country && (
            <div className="rfd-ui-invoice-table-address-window-prop-row">
              <span
                className={classNames('rfd-ui-invoice-table-address-window-prop-row-title', {
                  error: errors.get('state_id')
                })}
              >
                State:
              </span>
              <Select
                options={states}
                width={270}
                placeholder="Please select"
                onSelect={v => this.setAddress('state_id', v.get('value'))}
                value={row.get('data') ? row.getIn(['data', 'state_id']) : null}
              />
            </div>
          )}
          <div className="rfd-ui-invoice-table-address-window-prop-row">
            <span
              className={classNames('rfd-ui-invoice-table-address-window-prop-row-title', {
                error: errors.get('postal_code')
              })}
            >
              {18302 == country ? 'ZIP' : 'Postal'} Code:
            </span>
            <TextField
              width={270}
              debounce={100}
              onChange={v => this.setAddress('postal_code', v)}
              value={row.get('data') ? row.getIn(['data', 'postal_code']) : ''}
              charLimit={150}
            />
          </div>
          <Button label="SUBMIT" onClick={this.checkAddress} icon={loading ? 'icon-aytmfd-spin afd-spin' : ''} />
        </div>
      </LightBox>
    )
  }

  renderEmptyState() {
    const { row, width, valuesWidth } = this.props
    const note = row.get('note')
    const emptyText = row.get('text') || 'Physical address:'
    const editable = row.getIn(['data', 'editable'])
    const emptyPrompt = editable ? row.get('value') || 'Please, provide' : 'Address needed'

    return [
      <div className="rfd-ui-invoice-table-row-label" key="label" style={{ width: width }}>
        <div className="rfd-ui-invoice-table-text">
          <div className="rfd-ui-invoice-table-dotted">
            <div
              className={classNames('rfd-ui-invoice-table-dotted-text', {
                error: row.get('error')
              })}
            >
              {this.renderLeveledText(
                emptyText,
                row.get('level'),
                classNames('rfd-ui-invoice-table-row-label-text', {
                  error: row.get('error')
                })
              )}
            </div>
          </div>
          {row.get('message') && (
            <div>
              <div>
                {this.renderLeveledText(
                  row.get('message'),
                  row.get('level'),
                  classNames('rfd-ui-invoice-table-row-label-text small', {
                    error: row.get('error')
                  })
                )}
              </div>
            </div>
          )}
        </div>
      </div>,
      <div className="rfd-ui-invoice-table-row-value" key="value" style={{ width: valuesWidth }}>
        <div
          className={classNames('rfd-ui-invoice-table-attach-address rfd-ui-invoice-table-row-value-text', {
            disabled: !editable
          })}
          dangerouslySetInnerHTML={{ __html: this.preprocessText(emptyPrompt) }}
          onClick={editable ? this.changeEdit : null}
        />
        {note && (
          <PopupTrigger trigger="hover">
            <Popup
              direction="topleft"
              content={() => (
                <div>
                  <span dangerouslySetInnerHTML={{ __html: this.preprocessText(note) }} />
                </div>
              )}
              width="208px"
              popupOffset={15}
              borderSize={2}
              borderColor={'#73B0AC'}
              className="rfd-ui-popup-notification"
            >
              <i key="popupRefEl" className="icon-aytmfd-help" />
            </Popup>
          </PopupTrigger>
        )}
      </div>
    ]
  }

  cancelEdit() {
    this.setState({
      edit: false,
      message: null,
      error: false
    })
  }

  render() {
    const { row } = this.props
    const { edit } = this.state
    const empty = !row.value || 'Please provide' == row.value
    // const message = row.get('message') || this.state.message
    // const error = row.get('error') || this.state.error

    return (
      <div className="rfd-ui-invoice-table-row-bordered-container">
        {/*{edit && this.renderEditState()}*/}
        {empty && this.renderEmptyState()}
        {edit && this.renderWindow()}
      </div>
    )
  }
}
